import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setDairyCowSales } from "services";

import { FOOTPRINTING_DAIRY, FOOTPRINTING_DAIRY_PRIMARY_DATA, GET_DAIRY_COWS_SOLD } from "consts";

import { UploadableCowSales } from "models";

export const useMutateFootprintingDairyCowSales = (farmId: string, year: number, payload: UploadableCowSales, primaryDataId: string) => {
  const queryClient = useQueryClient();

  return useMutation(
    {
      mutationKey: [GET_DAIRY_COWS_SOLD],
      mutationFn: () => setDairyCowSales(primaryDataId, payload),
      onSuccess: async () => {
        const QKs = [
          [GET_DAIRY_COWS_SOLD, primaryDataId],
          [FOOTPRINTING_DAIRY_PRIMARY_DATA, primaryDataId],
          [FOOTPRINTING_DAIRY_PRIMARY_DATA, farmId, year],
          [FOOTPRINTING_DAIRY, farmId, year],
        ];
        await Promise.all(QKs.map((QK) => queryClient.invalidateQueries({ queryKey: QK })));
        await Promise.all(QKs.map((QK) => queryClient.refetchQueries({ queryKey: QK })));
      },
    },
    queryClient
  );
};
